<template>
    <div @mouseover="toggleSidebar" @mouseleave="hideSidebar">

        <div class="sidebar left" :class="{ open: isOpen, slim: !isOpen }">
            <ul class="list-sidebar bg-default mt-4">
                <li>
                    <router-link to="/resumos">
                        <i class="fas fa-clipboard-check mr-2 icon-sidebar"></i>
                        <span v-if="showLabels" class="nav-label">Resumos</span>
                    </router-link>
                </li>
                <li>
                    <router-link to="/cobrancas">
                        <i class="fas fa-money-check-alt mr-2 icon-sidebar"></i>
                        <span v-if="showLabels" class="nav-label">Cobranças</span>
                    </router-link>
                </li>
                <li>
                    <router-link to="/contratos">
                        <i class="fas fa-file-contract mr-2 icon-sidebar"></i>
                        <span v-if="showLabels" class="nav-label">Contratos</span>
                    </router-link>
                </li>
                <li>
                    <router-link to="/clientescob">
                        <i class="fa fa-users mr-2 icon-sidebar"></i>
                        <span v-if="showLabels" class="nav-label">Clientes Cobranças</span>
                    </router-link>
                </li>
                <hr>
                <li>
                    <router-link to="/empresasfat">
                        <i class="fa fa-building mr-2 icon-sidebar"></i>
                        <span v-if="showLabels" class="nav-label">Empresas Faturamento</span>
                    </router-link>
                </li>
                <li>
                    <router-link to="/tabcob">
                        <i class="fa fa-table mr-2 icon-sidebar"></i>
                        <span v-if="showLabels" class="nav-label">Tabela de Cobranças</span>
                    </router-link>
                </li>
                <li>
                    <router-link to="/ocorrencias">
                        <i class="fa fa-tags mr-2 icon-sidebar"></i>
                        <span v-if="showLabels"
                            class="nav-label">Ocorrências</span></router-link></li>
                <li>
                    <router-link to="/insumos">
                        <i class="fas fa-pallet mr-1 icon-sidebar"></i>
                        <span v-if="showLabels" class="nav-label">Insumos</span></router-link></li>
                <hr>
                <li>
                    <router-link to="/historico">
                        <i class="fas fa-clock mr-2 icon-sidebar"></i>
                        <span v-if="showLabels" class="nav-label">Histórico</span>
                    </router-link>
                </li>
                <li>
                    <router-link to="/perfis">
                        <i class="fas fa-id-card mr-2 icon-sidebar"></i>
                        <span v-if="showLabels" class="nav-label">Perfil de Acesso</span>
                    </router-link>
                </li>
                <li>
                    <router-link to="/usuarios">
                        <i class="fa fa-user mr-2 icon-sidebar"></i>
                        <span v-if="showLabels" class="nav-label">Usuários</span>
                    </router-link>
                </li>
                <li>
                    <router-link to="/cfg">
                        <i class="fa fa-cog mr-2 icon-sidebar"></i>
                        <span v-if="showLabels" class="nav-label">Configurações</span>
                    </router-link>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Sidebar',
    data() {
        return {
            isOpen: false,
            showLabels: false,
            labelTimeout: null, // ← aqui vai o ID do setTimeout
        };
    },
    methods: {

        toggleSidebar() {
            this.isOpen = true;

            // Garante que não tenha outro timeout rodando
            clearTimeout(this.labelTimeout);

            // Espera 250ms antes de mostrar os textos
            this.labelTimeout = setTimeout(() => {
                this.showLabels = true;
            }, 100);

            let containersImg = document.getElementsByClassName("container-img");
            if (containersImg.length > 0) {
                containersImg[0].style.paddingLeft = "250px";
            }
            
            let containersFluid = document.getElementsByClassName("container-fluid");
            if (containersFluid.length > 0) {
                containersFluid[0].style.paddingLeft = "270px";
            }
        },
        hideSidebar() {
            // Interrompe o timeout se o mouse sair antes dos 250ms
            clearTimeout(this.labelTimeout);

            this.showLabels = false;
            this.isOpen = false;

            let containersImg = document.getElementsByClassName("container-img");
            if (containersImg.length > 0) {
                containersImg[0].style.paddingLeft = "80px";
            }
            
            let containersFluid = document.getElementsByClassName("container-fluid");
            if (containersFluid.length > 0) {
                containersFluid[0].style.paddingLeft = "80px";
            }
        }
    },
};
</script>

<style>
.sidebar {
    width: 250px;
    text-align: left;
    margin-top: 41px;
    background: #2f4050;
    color: #fff;
    transition: all 0.1s ease;
    overflow-y: auto;
}

.sidebar.left {
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    z-index: 9999;
}

.sidebar.slim {
    width: 60px;
    padding-left: 7px;
}

.sidebar:not(.open) .nav-label {
    display: none;
}

.sidebar.slim a {
    justify-content: center;
}

.list-sidebar {
    list-style: none;
    padding: 0;
    margin: 0;
}

.list-sidebar li {
    padding: 10px 20px;
}

.list-sidebar li a {
    color: #fff;
    text-decoration: none;
    display: flex;
    align-items: center;
}

.sub-menu {
    padding-left: 20px;
}

.bg-default {
    background-color: #2f4050;
}

.fa-chevron-left {
    margin-left: auto;
}

.toggle-btn {
    position: fixed;
    top: 15px;
    left: 15px;
    background: #2f4050;
    color: #fff;
    border: none;
    padding: 10px;
    cursor: pointer;
    z-index: 1000;
    border-radius: 4px;
}

.icon-sidebar {
    font-size: 18px;
}

.nav-label {
    opacity: 0;
    transition: opacity 0.2s ease;
    position: absolute;
    left: 60px;
}

.sidebar.open .nav-label {
    opacity: 1;
}

</style>